module.exports = __webpack_public_path__ + "static/media/ic_conduite_nacelle.6f3c8b34.svg";